import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useEditTransactionCategoryGroup(id) {
  const queryClient = useQueryClient()

  const action = async ({ name = null, description = null }) => {
    const response = await httpClient.put(
      `/team/transaction-category/group/${id}`,
      {
        name,
        description,
      },
    )
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(
        e?.response?.data?.message ?? 'Something went wrong. Please try again.',
      )
    },
    onSuccess: (e) => {
      queryClient.invalidateQueries({ queryKey: ['transaction-categories'] })
      toast.success(e?.response?.data?.message ?? 'Changes saved successfully')
    },
  })

  return {
    editTransactionCategoryGroup: mutation.mutateAsync,
  }
}
